import React, { useState, useEffect, useRef } from "react";
import { f7, Page, Icon, Button } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";

const eatBidsLogo = require("./../images/logo/eatbids-logo.png");
function handleLogout() {
  localStorage.clear();
  f7.views.main.router.navigate("/login/");
}

const getImageAsBase64 = (imageUrl) => {
  return new Promise((resolve, reject) => {
    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      })
      .catch(reject);
  });
};

const ProfileUpdatePage = () => {
  const [data, setData] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [auth, setAuth] = useState(localStorage.getItem("auth"));
  const redLogin = () => {
    localStorage.clear();
    f7.views.main.router.navigate("/login/");
  };
  useEffect(() => {
    axios
      .get(API_BASE_URL + "customers", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          id: localStorage.getItem("id"),
          limits: 1,
        },
      })
      .then((response) => {
        setData(response.data[0]);
        const imageUrl = response.data[0].cust_image;
        if (imageUrl) {
          getImageAsBase64(IMG_URL + response.data[0].cust_image)
            .then((base64String) => setImagePreview(base64String))
            .catch((error) => console.log(error));
        }
      })
      .catch((error) => console.log(error));
  }, []);
  useEffect(() => {
    const id = localStorage.getItem("id");
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: "Basic " + API_AUTH,
    };
    axios
      .post(API_BASE_URL + "custauth", { id, token }, { headers })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          localStorage.setItem("auth", true);
          setAuth(true);
          // Introduce a delay of 1000 milliseconds (1 second) after API call success
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   f7.views.main.router.navigate('/main/');
          // }, 1000);
        } else {
          localStorage.setItem("auth", false);
          setAuth(false);
          // // Introduce a delay of 1000 milliseconds (1 second) after API call failure
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   // f7.views.main.router.navigate('/login/');
          // }, 1000);
        }
      })
      .catch((error) => {
        setAuth(false);
        // Introduce a delay of 1000 milliseconds (1 second) after API call error
        // setTimeout(() => {
        //   setIsLoading(false); // API call is complete even in case of an error
        //   console.log(error);
        //   // f7.views.main.router.navigate('/login/');
        // }, 1000);
      });
  });
  const divStyle = {
    backgroundImage: `url("${eatBidsLogo}")`, // Replace with the actual path to your image
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover", // Adjust as needed (e.g., 'contain', '100% 100%', etc.)
    backgroundPosition: "top left", // Positions the image at the top-left corner
    marginTop: "-30px",
    marginBottom: "-20px",
    marginLeft: "10px",
    width: "106px", // Set the width and height to fill the viewport
    height: "40px",
  };

  return (
    <Page className="bg-white">
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel pt-3">
                <h2>Profile</h2>
              </div>
              <div className="custom-logo d-none d-md-block" style={divStyle} />
            </div>
          </header>
          {auth ? (
            <>
              <section className="profile-form mt-3">
                <div className="custom-container p-0">
                  <div className="profile-cover">
                    {imagePreview ? (
                      <div className="preview-image-wrapper">
                        <img
                          className="img-fluid profile-pic"
                          src={imagePreview}
                          alt=""
                        />
                      </div>
                    ) : (
                      <div className=" no-image-placeholder text-center">
                        <div className="img-fluid profile-pic">
                          <Icon material="photo_camera" size={30} />
                          {/* <p>Tap to upload image</p> */}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="profile-name">
                    <h5>
                      {data.cust_fname} {data.cust_lname}
                    </h5>
                    <h6>{data.cust_email}</h6>
                  </div>
                </div>
              </section>

              <section>
                <div className="custom-container p-0">
                  <ul className="profile-list">
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/profile.svg").default}
                            alt="profile"
                          />
                        </div>
                        <a href="/profileedit/" className="profile-box-name">
                          <h5>Profile</h5>
                          <Icon
                            ios="material:keyboard_arrow_right"
                            aurora="material:keyboard_arrow_right"
                            md="material:keyboard_arrow_right"
                            className="theme-dark"
                          />
                          {/* <i className="ri-arrow-right-s-line arrow" /> */}
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/setting.svg").default}
                            alt="setting"
                          />
                        </div>
                        <a href="/setting/" className="profile-box-name">
                          <h5>Settings</h5>
                          <Icon
                            ios="material:keyboard_arrow_right"
                            aurora="material:keyboard_arrow_right"
                            md="material:keyboard_arrow_right"
                            className="theme-dark"
                          />
                        </a>
                      </div>
                    </li>
                    {/* <li>
                    <div className="profile-box">
                      <div className="profile-icon">
                        <img className="img-fluid icon" src={require("./../img/icon/manage-payment.svg").default} alt="Payment" />
                      </div>
                      <a href="/wallet/" className="profile-box-name">
                        <h5>Wallet</h5>
                        <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                      </a>
                    </div>
                  </li> */}
                    {/* <li>
                    <div className="profile-box">
                      <div className="profile-icon">
                        <img class="img-fluid icon" src={require("./../images/svg/whishlist.svg").default} alt="wishlist"/>                 
                      </div>
                      <a href="/cart/" className="profile-box-name">
                        <h5>WishList</h5>
                        <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                      </a>
                    </div>
                  </li> */}
                    {/* <li>
                    <div className="profile-box">
                      <div className="profile-icon">
                        <img className="img-fluid icon" src="profile-location.svg" alt="location" />
                      </div>
                      <a href="manage-delivery-address.html" className="profile-box-name">
                        <h5>Manage Delivery Address</h5>
                        <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                      </a>
                    </div>
                  </li> */}
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/my-order.svg").default}
                            alt="order"
                          />
                        </div>
                        <a href="/order/" className="profile-box-name">
                          <h5>Orders</h5>
                          <Icon
                            ios="material:keyboard_arrow_right"
                            aurora="material:keyboard_arrow_right"
                            md="material:keyboard_arrow_right"
                            className="theme-dark"
                          />
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/my-order.svg").default}
                            alt="past order"
                          />
                        </div>
                        <a href="/order_can_list/" className="profile-box-name">
                          <h5>Cancelled orders</h5>
                          <Icon
                            ios="material:keyboard_arrow_right"
                            aurora="material:keyboard_arrow_right"
                            md="material:keyboard_arrow_right"
                            className="theme-dark"
                          />
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/my-order.svg").default}
                            alt="past order"
                          />
                        </div>
                        <a href="/order_exp_list/" className="profile-box-name">
                          <h5>Expired orders</h5>
                          <Icon
                            ios="material:keyboard_arrow_right"
                            aurora="material:keyboard_arrow_right"
                            md="material:keyboard_arrow_right"
                            className="theme-dark"
                          />
                        </a>
                      </div>
                    </li>
                    {/* <li>
                    <div className="profile-box">
                      <div className="profile-icon">
                        <img className="img-fluid icon" src="#" alt="order" />
                      </div>
                      <a href="/help/" className="profile-box-name">
                        <h5>Help</h5>
                        <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="profile-box">
                      <div className="profile-icon">
                        <img className="img-fluid icon" src="#" alt="order" />
                      </div>
                      <a href="/about/" className="profile-box-name">
                        <h5>About</h5>
                        <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                      </a>
                    </div>
                  </li> */}
                    {/* <li>
                    <div className="profile-box">
                      <div className="profile-icon">
                        <img className="img-fluid icon" src="svg/notification-bing.svg" alt="bell" />
                      </div>
                      <a href="/notification/" className="profile-box-name">
                        <h5>Notifications</h5>
                        <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                      </a>
                    </div>
                  </li> */}
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/logout.svg").default}
                            alt="Logout"
                          />
                        </div>
                        <a
                          href="#"
                          onClick={handleLogout}
                          className="profile-box-name"
                        >
                          <h5>Log Out</h5>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div className="profile-box">
                        <div className="profile-icon">
                          <img
                            className="img-fluid icon"
                            src={require("./../img/icon/trash.svg").default}
                            alt="Delete"
                          />
                        </div>
                        <a href="/deleteaccount/" className="profile-box-name">
                          <h5 className="text-danger">Delete Account</h5>
                          <Icon
                            ios="material:keyboard_arrow_right"
                            aurora="material:keyboard_arrow_right"
                            md="material:keyboard_arrow_right"
                            className="theme-dark"
                          />
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
            </>
          ) : (
            <div className="custom-container mt-5">
              <div className="empty-tab">
                <h3 className="mt-5">Have eatbids account?</h3>
                {/* <h5 className="mt-3">You have currently no events.</h5> */}
                <a
                  onClick={redLogin}
                  className="btn theme-btn w-100 mt-4"
                  role="button"
                >
                  Log in
                </a>
              </div>
              <div class="division">
                <span>OR</span>
              </div>
              <div className="empty-tab">
                {/* <h2>New to Eatbid </h2> */}
                {/* <h5 className="mt-3">You have currently no events.</h5> */}
                {/* <a href="/register/" className="btn btn-success w-100 mt-5" role="button">Sign up</a> */}
                <p className="btn gray-btn mt-3 text-3 w-100">
                  {" "}
                  You don't have an account?{" "}
                  <a href="/register/" className="text-black">
                    Sign up
                  </a>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </Page>
  );
};

export default ProfileUpdatePage;
